import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { DashComponent } from './components/dash/dash.component';
import { AdminComponent } from './components/admin/admin.component';
import { Dash2Component } from './components/dash2/dash2.component';
import { DetailsComponent } from './components/details/details.component';
import { SaLogsComponent } from './components/sa-logs/sa-logs.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ScheduleModule } from '@syncfusion/ej2-angular-schedule';
import { NgxPaginationModule } from 'ngx-pagination';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AdminFilterPipe } from './pipes/AdminFilter.pipe';
import { LicenseFilterPipe } from './pipes/LicenseFilter.pipe';
import { HomeComponent } from './components/home/home.component';
import { LicenseDataService } from './services/LicenseData.service';
import { HeaderNsideService } from './services/HeaderNside.service';
import { TokenExpireInterceptor } from '../../core/TokenExpireInterceptor.interceptor';
import { SaHelpVideoComponent } from './components/sa-help-video/sa-help-video.component';
import { SaHelpVideoService } from './services/SaHelpVideo.service';
import { SaHelpVideoPipePipe } from './pipes/SaHelpVideoPipe.pipe';
import { SaLogPipePipe } from './pipes/SaLogPipe.pipe';
import { PaypalTransactionHistoryComponent } from './components/paypal-transaction-history/paypal-transaction-history.component';
import { SaPaypalServiceService } from './services/SaPaypalService.service';
import { SaPaypalInvoiceDetailsComponent } from './components/sa-paypal-invoice-details/sa-paypal-invoice-details.component';
import { PaypalPromocodeComponent } from './components/paypal-promocode/paypal-promocode.component';
import { SaPaypalPromocodeServiceService } from './services/SaPaypalPromocodeService.service';
import { SaPaypalPromocodeFilterPipe } from './pipes/SaPaypalPromocodeFilter.pipe';
import { SaPaypalInvoiceService } from './services/SaPaypalInvoice.service';
import { SaConfirmpasswordDirectiveDirective } from './directives/SaConfirmPassword.directive';
import { IpsTransactionHistoryComponent } from './components/ips-transaction-history/ips-transaction-history.component';
import { SaIpsTransactionFilterPipe } from './pipes/SaIpsTransactionFilter.pipe';
import { SaIpsInvoiceDetailsComponent } from './components/sa-ips-invoice-details/sa-ips-invoice-details.component';
import { SortColumnDirective } from './directives/SortColumn.directive';
import { TransactionHistoryCombinedComponent } from './components/transaction-history-combined/transaction-history-combined.component';
import { SearchPaypalTransactionHistoryPipe } from './pipes/SearchPaypalTransactionHistory.pipe';
import { SortIpsTransactionColumnDirective } from './directives/SortIpsTransactionColumn.directive';
import { SortPaypalTransactionColumnDirective } from './directives/SortPaypalTransactionColumn.directive';
import { SaActiveHistoryColumnSortDirective } from './directives/SaActiveHistoryColumnSort.directive';
import { SaDashboardColumnSortDirective } from './directives/SaDashboardColumnSort.directive';
import { SaAdminColumnSortDirective } from './directives/SaAdminColumnSort.directive';
import { SaNumberColumnSortDirective } from './directives/SaNumberColumnSort.directive';
import { SaRoutingModule } from './SaRouting.module';
import { QRCodeModule } from 'angularx-qrcode';
import { SharedModule } from '../shared/shared.module';
import { SaLicenseCardComponent } from './components/elements/sa-license-card/sa-license-card.component';
import { DashCardComponent } from './components/elements/dash-card/dash-card.component';
import { PromoCodeComponent } from './components/elements/promo-code/promo-code.component';
import { PlanCardsComponent } from './components/elements/plan-cards/plan-cards.component';
import { LinkCardsComponent } from './components/elements/link-cards/link-cards.component';
import { StorageListComponent } from './components/elements/storage-list/storage-list.component';
import { LicenseListComponent } from './components/elements/license-list/license-list.component';
import { ServiceListComponent } from './components/elements/service-list/service-list.component';
import { AdminListComponent } from './components/elements/admin-list/admin-list.component';
import { UpgradeCardsComponent } from './components/elements/upgrade-cards/upgrade-cards.component';
import { LedgeTableComponent } from './components/elements/ledge-table/ledge-table.component';
import { ActionTableComponent } from './components/elements/action-table/action-table.component';
import { PaymentInvoiceTableComponent } from './components/elements/payment-invoice-table/payment-invoice-table.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    QRCodeModule,
    ScheduleModule,
    NgxPaginationModule,
    InfiniteScrollModule,
    SaRoutingModule,
    SharedModule,
  ],
  providers: [
    LicenseDataService,
    HeaderNsideService,
    SaPaypalServiceService,
    SaPaypalPromocodeServiceService,
    SaPaypalInvoiceService,
    SaHelpVideoService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenExpireInterceptor,
      multi: true
    },
  ],
  declarations: [
    HomeComponent,

    HeaderComponent,
    SidebarComponent,
    DashComponent,
    AdminComponent,
    Dash2Component,
    DetailsComponent,
    SaLogsComponent,
    PaypalTransactionHistoryComponent,
    AdminFilterPipe,
    LicenseFilterPipe,
    SaHelpVideoComponent,
    SaHelpVideoPipePipe,
    SaLogPipePipe,
    SaPaypalInvoiceDetailsComponent,
    PaypalPromocodeComponent,
    SaPaypalPromocodeFilterPipe,
    SaConfirmpasswordDirectiveDirective,
    IpsTransactionHistoryComponent,
    SaIpsTransactionFilterPipe,
    SaIpsInvoiceDetailsComponent,
    SortColumnDirective,
    TransactionHistoryCombinedComponent,
    SearchPaypalTransactionHistoryPipe,
    SortIpsTransactionColumnDirective,
    SortPaypalTransactionColumnDirective,
    SaActiveHistoryColumnSortDirective,
    SaDashboardColumnSortDirective,
    SaAdminColumnSortDirective,
    SaNumberColumnSortDirective,
    SaLicenseCardComponent,
    DashCardComponent,
    PromoCodeComponent,
    PlanCardsComponent,
    LinkCardsComponent,
    StorageListComponent,
    LicenseListComponent,
    ServiceListComponent,
    AdminListComponent,
    UpgradeCardsComponent,
    LedgeTableComponent,
    ActionTableComponent,
    PaymentInvoiceTableComponent,

  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class SaModuleModule { }
